import { IProductTitle } from 'shared/types';

export const MAX_NAME_SPLITS = 20;

// TODO: change it to array of name splits
export const defaultAliasesInputValue = {
    ean: '',
    name: '',
    name_split_1: '',
    name_split_2: '',
    name_split_3: '',
    name_split_4: '',
    name_split_5: '',
    name_split_6: '',
    name_split_7: '',
    name_split_8: '',
    name_split_9: '',
    name_split_10: '',
    name_split_11: '',
    name_split_12: '',
    name_split_13: '',
    name_split_14: '',
    name_split_15: '',
    name_split_16: '',
    name_split_17: '',
    name_split_18: '',
    name_split_19: '',
    name_split_20: '',
};

// TODO: change it to array of name splits
export const emptyProductTitle: IProductTitle = {
    ean: '',
    name: '',
};
